import React, { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Landing from "./pages/Landing";
import Calculator from "./pages/Calculator";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import { api } from "./lib/ccsApi";

function Shell({ children }) {
    return (
        <div className="min-h-screen flex flex-col">
            <Header />
            <main className="flex-1">{children}</main>
            <Footer />
        </div>
    );
}

export default function App() {
    useEffect(() => {
        // Cache support email + donation URL globally for components that don't use the hook
        api.get("/config").then((r) => { window.__ccs_cfg = r.data; }).catch(() => {});
    }, []);

    return (
        <div className="App">
            <BrowserRouter>
                <Routes>
                    <Route path="/" element={<Shell><Landing /></Shell>} />
                    <Route path="/calculator" element={<Shell><Calculator /></Shell>} />
                    <Route path="/admin/login" element={<Shell><AdminLogin /></Shell>} />
                    <Route path="/admin" element={<Shell><AdminDashboard /></Shell>} />
                </Routes>
            </BrowserRouter>
            <Toaster richColors position="top-center" />
        </div>
    );
}
